import React, { useState } from 'react';

// Components
import { HistoricalScenariosFilter, ScenarioGraph } from './components';

// Hooks
import { useHistoricalScenariosState } from './hooks/useHistoricalScenariosState';

// Utils
import { formatMessage } from '@/utils/i18n';
import ChartPicker from '../Charts/components/chart-header/ChartPicker';
import { PERFORMANCE_CHART } from '@/utils/constants';

const charts = [PERFORMANCE_CHART.GROWTH, PERFORMANCE_CHART.RISK_REWARD, PERFORMANCE_CHART.DRAWDOWN];

interface HistoricalScenariosProps {
  readOnly?: boolean;
}

const HistoricalScenarios: React.FC<HistoricalScenariosProps> = ({ readOnly }) => {
  const { activeComparison, availableScenarios, drawdownData, scatterPlotData, selectedHistoricalScenarios, locale, seriesData, user, isLoading } =
    useHistoricalScenariosState();
  const [selectedChart, setSelectedChart] = useState<PERFORMANCE_CHART>(PERFORMANCE_CHART.GROWTH);

  if (!availableScenarios || availableScenarios.length === 0) {
    return <p>{formatMessage('Comparison.HistoricalScenarios.NoScenariosAvailable')}</p>;
  }

  return (
    <>
      <div className="historical-scenarios-header-actions">
        <HistoricalScenariosFilter user={user} readOnly={readOnly} />
        <ChartPicker charts={charts} value={selectedChart} onChange={setSelectedChart} />
      </div>
      <ScenarioGraph
        activeComparison={activeComparison}
        drawdownData={drawdownData}
        scatterPlotData={scatterPlotData}
        seriesData={seriesData}
        locale={locale}
        selectedHistoricalScenarios={selectedHistoricalScenarios}
        selectedChart={selectedChart}
        user={user}
        isLoading={isLoading}
      />
    </>
  );
};

export default HistoricalScenarios;
